/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { KAI_SHIKI_MODAL_COLORS, KAI_SHIKI_MODAL_EFFECTS } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';

export const MODAL_COLORS = KAI_SHIKI_MODAL_COLORS;
export const MODAL_EFFECTS = KAI_SHIKI_MODAL_EFFECTS;

export const MODAL_CAPTION_STYLE = css`
  label: MODAL_CAPTION_STYLE;
  font-family: CircularXX, sans-serif;
  font-size: ${pxToRem(10)};
  font-style: normal;
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: 0.2px;
`;

export const MODAL_ACTION_BUTTON_STYLE = css`
  label: MODAL_ACTION_BUTTON_STYLE;
  min-height: 32px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  font-family: CircularXX, sans-serif;
  font-size: ${pxToRem(12)};
  font-style: normal;
  font-weight: 700;
  line-height: 1.167;
  letter-spacing: 0.24px;
`;
